export default "__VITE_ASSET__DoTTC6pD__"